import { ICONS } from './icons/index.web'
import type { VariantStyleMap } from './types'

export const VARIANT_STYLE_MAP: VariantStyleMap = {
  error: {
    icon: ICONS.error,
  },
  warning: {
    icon: ICONS.warning,
  },
  success: {
    icon: ICONS.success,
  },
}
